import { render } from "./edit_form.vue?vue&type=template&id=bbaf078a&scoped=true"
import script from "./edit_form.vue?vue&type=script&lang=js"
export * from "./edit_form.vue?vue&type=script&lang=js"

import "./edit_form.vue?vue&type=style&index=0&id=bbaf078a&scoped=true&lang=css"
import "./edit_form.vue?vue&type=style&index=1&id=bbaf078a&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_pms_web\\pms_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbaf078a"]])

export default __exports__